<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
      <div class="bg-white page-border" [ngStyle]="{'height': pageHeight+'px'}"> 
      <!--page body contant -->
        
    <div class="row row-replace">   
          <!-- header card row -->
          <div class="col-md-12 col-sm-12 col-lg-2 col-xl-2 col-p">
             <div class="card dash-widget card-mb">
                <div class="card-body text-center">
                    <div class="d-flex flex-column align-items-center text-center">
                     <img src="assets/img/user.jpeg" alt="Admin" class="rounded-circle" width="150">
                        <div class="mt-3">
                           <h3>Ashish Sharma</h3>
                           <h4 class="text-secondary mb-1">Director </h4>
                           <p class="text-muted font-size-sm">Employee id:454545</p>
                           <p class="text-muted font-size-sm">ashishsharma@gmail.com</p>
                           <button class="btn btn-outline-primary m-b-10">Message</button>
                           <p class="text-muted font-size-sm">Reporting Manager</p>
                           <p class="text-muted font-size-sm">Location</p>
                           <p class="text-muted font-size-sm" [ngStyle]="{'color': 'red'}">Others</p>
                        </div>
                     </div>
                </div>
             </div>
          </div>
          <div class="col-md-12 col-sm-12 col-lg-10 col-xl-10 col-p">
                
                
                <section class="container-fluid">
                    <div class="row body-scroll">
                        <div class="col">
                            <ul class="nav nav-tabs nav-tabs-bottom row">
                                <li class="nav-item"><a class="nav-link active" href="#profile-tab1" data-toggle="tab"><i class="fa fa-user"></i> Profiles</a></li>
                                <li class="nav-item"><a class="nav-link" href="#profile-tab2" data-toggle="tab"><i class="fa fa-address-book"></i> Address</a></li>
                                <li class="nav-item"><a class="nav-link" href="#profile-tab3" data-toggle="tab"><i class="fa fa-graduation-cap"></i> Education / Experience</a></li>
                                <li class="nav-item"><a class="nav-link" href="#profile-tab4" data-toggle="tab"><i class="fa fa-university"></i> Bank & Statutory</a></li>
                                <!-- <li class="nav-item"><a class="nav-link" href="#profile-tab5" data-toggle="tab"><i class="fa fa-users"></i> Family</a></li>
                                <li class="nav-item"><a class="nav-link" href="#profile-tab6" data-toggle="tab"><i class="fa fa-briefcase"></i> Projects</a></li> -->

                            </ul>
                            <div class="tab-content">
                                <nav class="tab-pane active" id="profile-tab1">
                                    <div class="row">
                                        <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                           <div class="card flex-fill add-mrf-card">
                                              <div class="card-body card-padding-bottom">
                                                 <h3 class="card-title page-header0"><i class="fa fa-book"></i> Personal Informations</h3>
                                                 <hr>
                                                 <ul class="personal-info m-l-15">
                                                    <li>
                                                       <div class="title">Passport No</div>
                                                       <div class="text"> 105645154</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Passport Exp Date</div>
                                                       <div class="text"> 01/01/2020</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Tel</div>
                                                       <div class="text">5487515784</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Nationality</div>
                                                       <div class="text">india</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Religion</div>
                                                       <div class="text">hindu</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Marital status</div>
                                                       <div class="text">Married</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">Spouse</div>
                                                       <div class="text">Yes</div>
                                                    </li>
                                                    <li>
                                                       <div class="title">No. of children</div>
                                                       <div class="text">2</div>
                                                    </li>
                                                 </ul>
                                                 
                                              </div>
                                           </div>
                                        </div>
                                     </div>
                                     <div class="row">
                                       <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                          <div class="card flex-fill add-mrf-card">
                                             <div class="card-body card-padding-bottom">
                                                <h3 class="card-title page-header0"><i class="fa fa-book"></i> Emergency Contact</h3>
                                                <hr>
                                                <h4><i class="fa fa-phone"></i> Primary</h4>
                                                <ul class="personal-info m-l-15">
                                                   <li>
                                                      <div class="title">Name</div>
                                                      <div class="text"> John Doe</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Relationship</div>
                                                      <div class="text">Father</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Phone</div>
                                                      <div class="text">9876543210 , 9876543210</div>
                                                   </li>
                                                </ul>
                                                <h4> <i class="fa fa-phone"></i> Secondary</h4>
                                                <ul class="personal-info m-l-15">
                                                   <li>
                                                      <div class="title">Name</div>
                                                      <div class="text"> Karen Wills</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Relationship</div>
                                                      <div class="text">Brother</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Phone</div>
                                                      <div class="text">9876543210 , 9876543210</div>
                                                   </li>
                                                </ul>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                </nav>
                                <nav class="tab-pane" id="profile-tab2">
                                       <div class="row">
                                          <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                             <div class="card flex-fill add-mrf-card">
                                                <div class="card-body card-padding-bottom">
                                                   <h3 class="card-title page-header0"><i class="fa fa-book"></i> Primary Address</h3>
                                                   <hr>
                                                   <ul class="personal-info m-l-15">
                                                      <li>
                                                         <div class="title">Full Name </div>
                                                         <div class="text"> Ravi Kumar Singh</div>
                                                      </li>
                                                      <li>
                                                         <div class="title">Address</div>
                                                         <div class="text"> 1861 Bayonne Ave, Manchester Township, NJ, 08759</div>
                                                      </li>
                                                      <li>
                                                         <div class="title">State</div>
                                                         <div class="text">Haryana</div>
                                                      </li>
                                                      <li>
                                                         <div class="title">Country</div>
                                                         <div class="text">india</div>
                                                      </li>
                                                      <li>
                                                         <div class="title">Religion</div>
                                                         <div class="text">hindu</div>
                                                      </li>
                                                      
                                                   </ul>
                                                   
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                       <div class="row">
                                       <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                          <div class="card flex-fill add-mrf-card">
                                             <div class="card-body card-padding-bottom">
                                                <h3 class="card-title page-header0"><i class="fa fa-book"></i> Secondary Address</h3>
                                                <hr>
                                                <ul class="personal-info m-l-15">
                                                   <li>
                                                      <div class="title">Full Name </div>
                                                      <div class="text"> Ravi Kumar Singh</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Address</div>
                                                      <div class="text"> 1861 Bayonne Ave, Manchester Township, NJ, 08759</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">State</div>
                                                      <div class="text">Haryana</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Country</div>
                                                      <div class="text">india</div>
                                                   </li>
                                                   <li>
                                                      <div class="title">Religion</div>
                                                      <div class="text">hindu</div>
                                                   </li>
                                                   
                                                </ul>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                </nav>
                                <nav class="tab-pane" id="profile-tab3">
                                    <div class="row">
                                       <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                          <div class="card flex-fill add-mrf-card">
                                             <div class="card-body card-padding-bottom">
                                                <h3 class="card-title page-header0"><i class="fa fa-graduation-cap"></i> Education Details</h3>
                                                <hr>
                                                <div class="experience-box add-p-b10">
                                                   <ul class="experience-list">
                                                       <li>
                                                           <div class="experience-user">
                                                               <div class="before-circle"></div>
                                                           </div>
                                                           <div class="experience-content">
                                                               <div class="timeline-content">
                                                                   <a href="#/" class="name">International College of Arts and Science (UG)</a>
                                                                   <div>Bsc Computer Science</div>
                                                                   <span class="time">2000 - 2003</span>
                                                               </div>
                                                           </div>
                                                       </li>
                                                       <li>
                                                           <div class="experience-user">
                                                               <div class="before-circle"></div>
                                                           </div>
                                                           <div class="experience-content">
                                                               <div class="timeline-content">
                                                                   <a href="#/" class="name">International College of Arts and Science (PG)</a>
                                                                   <div>Msc Computer Science</div>
                                                                   <span class="time">2000 - 2003</span>
                                                               </div>
                                                           </div>
                                                       </li>
                                                       <li>
                                                         <div class="experience-user">
                                                             <div class="before-circle"></div>
                                                         </div>
                                                         <div class="experience-content">
                                                             <div class="timeline-content">
                                                                 <a href="#/" class="name">International College of Arts and Science (PG)</a>
                                                                 <div>Msc Computer Science</div>
                                                                 <span class="time">2000 - 2003</span>
                                                             </div>
                                                         </div>
                                                     </li>
                                                   </ul>
                                               </div>
                                                
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="row">
                                       <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                          <div class="card flex-fill add-mrf-card">
                                             <div class="card-body card-padding-bottom">
                                                <h3 class="card-title page-header0"><i class="fa fa-graduation-cap"></i> Experience</h3>
                                                <hr>
                                                <div class="experience-box add-p-b10">
                                                   <ul class="experience-list">
                                                       <li>
                                                           <div class="experience-user">
                                                               <div class="before-circle"></div>
                                                           </div>
                                                           <div class="experience-content">
                                                               <div class="timeline-content">
                                                                   <a href="#/" class="name">Web Designer at Zen Corporation</a>
                                                                   <div>Jan 2013 - Present (5 years 2 months)</div>
                                                                   <span class="time">2000 - 2003</span>
                                                               </div>
                                                           </div>
                                                       </li>
                                                       <li>
                                                           <div class="experience-user">
                                                               <div class="before-circle"></div>
                                                           </div>
                                                           <div class="experience-content">
                                                               <div class="timeline-content">
                                                                  <a href="#/" class="name">Web Designer at Zen Corporation</a>
                                                                  <div>Jan 2013 - Present (5 years 2 months)</div>
                                                                  <span class="time">2000 - 2003</span>
                                                               </div>
                                                           </div>
                                                       </li>
                                                       <li>
                                                         <div class="experience-user">
                                                             <div class="before-circle"></div>
                                                         </div>
                                                         <div class="experience-content">
                                                             <div class="timeline-content">
                                                               <a href="#/" class="name">Web Designer at Zen Corporation</a>
                                                               <div>Jan 2013 - Present (5 years 2 months)</div>
                                                               <span class="time">2000 - 2003</span>
                                                             </div>
                                                         </div>
                                                     </li>
                                                   </ul>
                                               </div>
                                                
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                               
        
                              </nav>
                              <nav class="tab-pane" id="profile-tab4">
                                 <div class="row">
                                    <div class="col-md-12 d-flex padding-right-2 padding-left-2">
                                       <div class="card flex-fill add-mrf-card">
                                          <div class="card-body card-padding-bottom">
                                             <h3 class="card-title page-header0"><i class="fa fa-book"></i>Bank information</h3>
                                             <hr>
                                             <ul class="personal-info m-l-15">
                                                <li>
                                                   <div class="title">Bank name</div>
                                                   <div class="text"> ICICI Bank</div>
                                                </li>
                                                <li>
                                                   <div class="title">Bank account No</div>
                                                   <div class="text">159843014641</div>
                                                </li>
                                                <li>
                                                   <div class="title">IFSC Code</div>
                                                   <div class="text">ICI24504</div>
                                                </li>
                                                <li>
                                                   <div class="title">PAN No</div>
                                                   <div class="text">TC000Y56</div>
                                                </li>
                                               
                                             </ul>
                                             
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </nav>
                              <nav class="tab-pane" id="profile-tab5">
                                 <div class="row staff-grid-row">
                                    <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                        <div class="profile-widget">
                                            <div class="profile-img">
                                                <a href="profile" class="avatar"><img src="public/img/profiles/avatar-02.jpg" alt=""></a>
                                            </div>
                                            <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">John Doe</a></h4>
                                            <div class="small text-muted">Web Designer</div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                        <div class="profile-widget">
                                            <div class="profile-img">
                                                <a href="profile" class="avatar"><img src="public/img/profiles/avatar-09.jpg" alt=""></a>
                                            </div>
                                            <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">Richard Miles</a></h4>
                                            <div class="small text-muted">Web Developer</div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                        <div class="profile-widget">
                                            <div class="profile-img">
                                                <a href="profile" class="avatar"><img src="public/img/profiles/avatar-10.jpg" alt=""></a>
                                            </div>
                                            <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">John Smith</a></h4>
                                            <div class="small text-muted">Android Developer</div>
                                        </div>
                                     </div>
                                     <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                       <div class="profile-widget">
                                           <div class="profile-img">
                                               <a href="profile" class="avatar"><img src="public/img/profiles/avatar-02.jpg" alt=""></a>
                                           </div>
                                           <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">John Doe</a></h4>
                                           <div class="small text-muted">Web Designer</div>
                                       </div>
                                   </div>
                                   <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                       <div class="profile-widget">
                                           <div class="profile-img">
                                               <a href="profile" class="avatar"><img src="public/img/profiles/avatar-09.jpg" alt=""></a>
                                           </div>
                                           <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">Richard Miles</a></h4>
                                           <div class="small text-muted">Web Developer</div>
                                       </div>
                                   </div>
                                   <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-4">
                                       <div class="profile-widget">
                                           <div class="profile-img">
                                               <a href="profile" class="avatar"><img src="public/img/profiles/avatar-10.jpg" alt=""></a>
                                           </div>
                                           <h4 class="user-name m-t-10 mb-0 text-ellipsis"><a href="profile">John Smith</a></h4>
                                           <div class="small text-muted">Android Developer</div>
                                       </div>
                                    </div>
                                    
                                </div>

                              </nav>
                              <nav class="tab-pane" id="profile-tab6">
                                   
                              </nav>
                              
                           
                            </div> 
                             
                            <!--end here-->
                        </div>
                    </div>
                </section>
          
          </div>

    </div>
  
       
      <!--end page body contant -->
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  